module.exports = __webpack_public_path__ + "media/images/marinade-logo-6de1b4e9.svg";